import { DialogComponent } from '@theme/dialog';

/**
 * `<mega-menu-component>` — the site navigation panel (sections/mega.liquid).
 * A DialogComponent that keeps whatever sits above the header (announcement bar,
 * promo banner) visible while open: before opening it measures where the header
 * currently starts and exposes that as `--mega-menu-offset` on the dialog, which
 * the section CSS uses to push the dialog and its ::backdrop down.
 *
 * @extends {DialogComponent}
 */
class MegaMenuComponent extends DialogComponent {
  showDialog() {
    const { dialog } = this.refs;
    const header = document.getElementById('header-component');

    // Measured before super.showDialog() fixes the body, so the rect reflects the
    // current scroll position. A sticky or scrolled-away header yields 0.
    const offset = header ? Math.max(0, Math.round(header.getBoundingClientRect().top)) : 0;
    dialog.style.setProperty('--mega-menu-offset', `${offset}px`);

    super.showDialog();
  }
}

if (!customElements.get('mega-menu-component')) {
  customElements.define('mega-menu-component', MegaMenuComponent);
}
